import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { settingsService } from '../services/api'

const Logo = ({ 
  variant = 'header', // 'header' or 'hero'
  className = '',
  showText = true,
  textClassName = ''
}) => {
  const { data: settings, isLoading } = useQuery({
    queryKey: ['storeSettings'],
    queryFn: settingsService.getSettings,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })

  // Don't show anything while loading settings
  if (isLoading) {
    return null
  }

  const logoUrl = settings?.logo ? `/uploads/settings/${settings.logo}` : null
  const storeName = settings?.store_name || 'سبحات'

  if (variant === 'header') {
    return (
      <div className={`flex items-center space-x-2 ${className}`}>
        {logoUrl ? (
          <img 
            src={logoUrl} 
            alt={storeName}
            className="w-8 h-8 rounded-lg object-cover"
            onError={(e) => {
              // Fallback to default if image fails to load
              e.target.style.display = 'none'
              e.target.nextSibling.style.display = 'flex'
            }}
          />
        ) : null}
        
        {/* Fallback default logo */}
        <div 
          className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center"
          style={{ display: logoUrl ? 'none' : 'flex' }}
        >
          <span className="text-white font-bold">
            {storeName.substring(0, 2).toUpperCase()}
          </span>
        </div>
        
        {showText && (
          <span className={`text-xl font-bold text-gray-900 ${textClassName}`}>
            {storeName}
          </span>
        )}
      </div>
    )
  }

  if (variant === 'hero') {
    return (
      <div className={`flex justify-center ${className}`}>
        <div className="w-64 h-64 bg-white rounded-full flex items-center justify-center overflow-hidden shadow-lg">
          {logoUrl ? (
            <img 
              src={logoUrl} 
              alt={storeName}
              className="w-48 h-48 object-contain rounded-full"
              onError={(e) => {
                // Fallback to default if image fails to load
                e.target.style.display = 'none'
                e.target.nextSibling.style.display = 'flex'
              }}
            />
          ) : null}
          
          {/* Fallback default logo */}
          <div 
            className="w-full h-full flex items-center justify-center"
            style={{ display: logoUrl ? 'none' : 'flex' }}
          >
            <div className="text-center">
              <div className="w-32 h-32 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-4xl">
                  {storeName.substring(0, 2).toUpperCase()}
                </span>
              </div>
              {showText && (
                <span className={`text-2xl font-bold text-gray-700 ${textClassName}`}>
                  {storeName}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Default fallback
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
        <span className="text-white font-bold">
          {storeName.substring(0, 2).toUpperCase()}
        </span>
      </div>
      {showText && (
        <span className={`text-xl font-bold text-gray-900 ${textClassName}`}>
          {storeName}
        </span>
      )}
    </div>
  )
}

export default Logo
